import React from "react";
import { MdEmail, MdLocalPhone } from "react-icons/md";
import ContactInfoitem from "./ContactInfoitem";
import SectionTitle from "./SectionTitle";
import ContactForm from "./ContactForm";

export default function ContactSection() {
  return (
    <div>
      <div className="contactSection__wrapper">
        <div className="contact__section">
          <SectionTitle
            className="section-title"
            subheading="Get In Touch"
            heading="Contact"
          />
          <div className="contactSection__wrapAll">
            <div className="left">
              <ContactInfoitem icon={<MdLocalPhone />} text="+2348055966944" />
              <ContactInfoitem icon={<MdEmail />} text="Holaszyd1@gmail.com" />
              <ContactInfoitem text="Lagos, Nigeria" />
            </div>
            <div className="right">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
